import { render, staticRenderFns } from "./linkManage.vue?vue&type=template&id=6e2d8b3e&scoped=true"
import script from "./linkManage.vue?vue&type=script&lang=js"
export * from "./linkManage.vue?vue&type=script&lang=js"
import style0 from "./linkManage.vue?vue&type=style&index=0&id=6e2d8b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d8b3e",
  null
  
)

export default component.exports